<template>
  <div class="ActivityType-detail-page w-100">
    <b-form @submit="handleValidate">
      <basic-subheader>
        <template v-slot:actions>
          <b-button
            class="btn btn-light ml-3"
            type="button"
            @click="returnPage"
          >
            <span class="svg-icon">
              <inline-svg src="/media/svg/icons/Neolex/Arrows/arrow-left.svg" />
            </span>
            Huỷ
          </b-button>
          <b-button class="btn btn-light ml-3" type="button" @click="resetData">
            <span class="svg-icon">
              <inline-svg src="/media/svg/icons/Neolex/Basic/refresh-cw.svg" />
            </span>
            Reset dữ liệu
          </b-button>
          <template>
            <b-button class="btn btn-success ml-3" @click.stop="handleValidate">
              <span class="svg-icon">
                <inline-svg
                  :src="`/media/svg/icons/Neolex/Basic/${
                    isCreateForm ? 'plus' : 'save'
                  }.svg`"
                />
              </span>
              {{ isCreateForm ? 'Tạo mới' : ' Cập nhật' }}
            </b-button>
          </template>
        </template>
      </basic-subheader>
      <b-overlay :show="loading">
        <b-container fluid class="ActivityType-list-page__body mb-6 mt-6">
          <b-row>
            <b-col>
              <div class="card card-custom gutter-b w-100">
                <div class="card-body mt-0">
                  <h5 class="card-title text-success">
                    Thông tin Loại hoạt động
                  </h5>
                  <b-row>
                    <!-- <b-col cols="1">
                          <template v-if="form_type === 'edit'">
                            <h5 class="mt-4">{{ form.id }}</h5>
                            <div>
                              <span>Mã số: {{ form.id }}</span>
                            </div>
                            <div class="d-flex align-items-center mt-2">
                              <span
                                class="btn btn-active"
                                style="width: 95px; cursor: default"
                                v-if="form.status === 1">
                                Active
                              </span>
                              <span
                                class="btn btn-inactive"
                                style="width: 95px; cursor: default"
                                v-if="form.status === 0">
                                Inactive
                              </span>
                              <span
                                class="btn btn-ActivityType ml-3"
                                style="width: 95px; cursor: default">
                                Portal User
                              </span>
                            </div>
                          </template>
                    </b-col> -->
                    <b-col>
                      <b-row>
                        <b-col cols="3">
                          <basic-input
                            label="Mã loại hoạt động"
                            placeholder="Mã loại hoạt động"
                            name="code"
                            data-vv-As="Mã loại hoạt động"
                            :required="true"
                            v-validate="'required'"
                            :value.sync="form.code"
                            :state="validateState('code')"
                            :invalidFeedback="errors.first('code')"
                          ></basic-input>
                        </b-col>
                        <b-col cols="3">
                          <basic-input
                            label="Tên loại hoạt động"
                            placeholder="Tên loại hoạt động"
                            name="name"
                            data-vv-As="Tên loại hoạt động"
                            :required="true"
                            v-validate="'required'"
                            :value.sync="form.name"
                            :state="validateState('name')"
                            :invalidFeedback="errors.first('name')"
                          ></basic-input>
                        </b-col>
                        <b-col cols="3">
                          <basic-select
                            label="Cấp độ"
                            placeholder="Chọn cấp độ"
                            name="level"
                            :options="setupList.levels"
                            :value.sync="form.levelId"
                            track-by="value"
                            v-validate="'required'"
                            value-label="name"
                            data-vv-as="Cấp độ"
                            :state="validateState('level')"
                            :invalidFeedback="errors.first('level')"
                            @input="selected($event, 'level', setupList.levels)"
                            :required="true"
                          ></basic-select>
                        </b-col>
                        <b-col cols="3">
                          <basic-select
                            label="Trạng thái"
                            placeholder="Chọn trạng thái"
                            name="status"
                            :options="status"
                            :value.sync="form.status"
                            track-by="value"
                            v-validate="'required'"
                            value-label="name"
                            :state="validateState('status')"
                            data-vv-as="Trạng thái"
                            :invalidFeedback="errors.first('status')"
                            :required="true"
                            @input="selected($event, 'status', status)"
                          ></basic-select>
                        </b-col>
                        <b-col cols="3">
                          <basic-input
                            label="Detail Link"
                            placeholder="Detail Link"
                            name="detaillink"
                            data-vv-As="Detaillink"
                            :required="false"
                            :value.sync="form.detailLink"
                          ></basic-input>
                        </b-col>
                        <b-col cols="3">
                          <basic-input
                            label="Redirect Link"
                            placeholder="Redirect Link"
                            name="redirectlink"
                            data-vv-As="Redirectlink"
                            :required="false"
                            :value.sync="form.redirectLink"
                          ></basic-input>
                        </b-col>
                        <b-col cols="3">
                          <basic-input
                            label="Thứ tự hiển thị"
                            placeholder="Thứ tự hiển thị"
                            name="displayIndex"
                            data-vv-As="Thứ tự hiển thị"
                            :required="true"
                            v-validate="'required|min_value:0'"
                            :value.sync="form.displayIndex"
                            :state="validateState('displayIndex')"
                            :invalidFeedback="errors.first('displayIndex')"
                          ></basic-input>
                        </b-col>

                        <b-col cols="3">
                          <basic-input
                            label="Ghi chú"
                            placeholder="Ghi chú"
                            name="note"
                            data-vv-As="Ghi chú"
                            :required="true"
                            v-validate="'required'"
                            :value.sync="form.note"
                            :state="validateState('note')"
                            :invalidFeedback="errors.first('note')"
                          ></basic-input>
                        </b-col>
                        <b-col cols="3">
                          <basic-input
                            label="Số lần nhắc nhở"
                            placeholder="Số lần nhắc nhở"
                            name="subject"
                            v-model.number="reminders.RemindersCount"
                            v-validate="'required|min_value:0'"
                            :required="false"
                            :value.sync="reminders.RemindersCount"
                            type="number"
                            min="0"
                          ></basic-input>
                        </b-col>
                        <b-col cols="3">
                          <div class="form-group">
                            <label class="color-label">Màu</label>
                            <div class="color-picker-container">
                              <input
                                type="color"
                                name="color"
                                v-model="form.color"
                                v-validate="'required'"
                                class="w-100 rounded-pill"
                                :class="{
                                  'is-invalid': errors.has('color'),
                                  'is-valid':
                                    validateState('color') &&
                                    !errors.has('color'),
                                }"
                              />
                              <span
                                v-if="errors.has('color')"
                                class="invalid-feedback"
                                >{{ errors.first('color') }}</span
                              >
                            </div>
                          </div>
                        </b-col>
                      </b-row>
                      <div
                        v-for="(remind, index) in sortedRemind"
                        :key="remind.id || index"
                        v-if="index < reminders.RemindersCount"
                      >
                        <hr />
                        <b-row class="pt-4">
                          <b-col cols="1">
                            <p style="margin-top: 25px">Lần {{ index + 1 }}</p>
                          </b-col>
                          <b-col cols="3">
                            <basic-select
                              label="Ngày nhắc nhở"
                              placeholder="Chọn ngày nhắc nhở"
                              name="timeReminder"
                              :options="setupList.activityReminders"
                              track-by="value"
                              value-label="name"
                              :value.sync="reminders.remind[index].date"
                            >
                            </basic-select>
                          </b-col>
                          <b-col cols="2">
                            <label>Thời gian nhắc nhở</label>
                            <b-form-timepicker
                              :required="true"
                              placeholder="Chọn thời gian"
                              :hour12="true"
                              v-model="reminders.remind[index].time"
                            ></b-form-timepicker>
                          </b-col>
                          <b-col cols="1">
                            <b-button
                              @click="deleteRow(index)"
                              style="margin-top: 20px"
                            >
                              Xóa
                            </b-button>
                          </b-col>
                          <b-col cols="5" class="px-8">
                            <basic-text-editors
                              class="w-100"
                              label="Nội dung"
                              :showEmojiButton="true"
                              placeholder="Nhập nội dung"
                              name="detailLink"
                              :value.sync="reminders.remind[index].content"
                            ></basic-text-editors>
                          </b-col>
                        </b-row>
                      </div>
                    </b-col>
                  </b-row>
                </div>
                <div
                  class="card-footer d-flex align-items-lg-center justify-content-center"
                >
                  <b-button
                    class="btn btn-light ml-3"
                    type="button"
                    @click.stop="resetData"
                  >
                    <span class="svg-icon">
                      <inline-svg
                        src="/media/svg/icons/Neolex/Basic/refresh-cw.svg"
                      />
                    </span>
                    Reset dữ liệu
                  </b-button>
                  <b-button
                    class="btn btn-success ml-3"
                    @click.stop="handleValidate"
                  >
                    <span class="svg-icon">
                      <inline-svg
                        :src="`/media/svg/icons/Neolex/Basic/${
                          isCreateForm ? 'plus' : 'save'
                        }.svg`"
                      />
                    </span>
                    {{ isCreateForm ? 'Tạo mới' : 'Cập nhật' }}
                  </b-button>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-container>
      </b-overlay>
    </b-form>
  </div>
</template>

<script>
import 'vue2-datepicker/index.css';
export default {
  components: {},
  props: {
    id: {
      type: String,
      default: null,
    },
    form_type: {
      type: String,
      default: 'edit',
    },
  },
  data() {
    return {
      status: [
        {
          name: 'Hoạt động',
          value: 0,
        },
        {
          name: 'Không hoạt động',
          value: 1,
        },
        {
          name: 'Nháp',
          value: 2,
        },
      ],
      reminders: {
        RemindersCount: 0,
        remind: [{ date: '', time: '', content: '' }],
      },
      file: null,
      form: [],
      setupList: [],
      preview: null,
      loading: false,
    };
  },
  created() {
    this.initDataInSelect();
    this.loadActivityTypeData();
    this.getProgramActivityLevel();
  },
  computed: {
    nationId() {
      return this.form.nation?.id;
    },
    provinceId() {
      return this.form.province?.id;
    },
    districtId() {
      return this.form.district?.id;
    },
    isCreateForm() {
      return this.form_type === 'create' || this.form_type === 'copy';
    },
    sortedRemind() {
      return this.reminders.remind.slice().sort((a, b) => {
        const [hA, mA] = a.time.split(':').map(Number);
        const [hB, mB] = b.time.split(':').map(Number);
        return hA * 60 + mA - (hB * 60 + mB);
      });
    },
    levelValue() {
      if (typeof this.form.level === 'object') {
        return this.form.level?.value;
      }
      return this.form.level || this.form.levelId?.value || this.form.levelId;
    },
    preReminderContain() {
      return this.reminders.remind.map((r) => ({
        date: typeof r.date === 'object' ? r.date.value : r.date,
        time: r.time,
        content: r.content,
      }));
    },
  },
  watch: {
    'reminders.RemindersCount': {
      handler(newValue) {
        if (newValue < 0) {
          this.reminders.RemindersCount = 0;
          this.$toastr.e({
            title: 'Lỗi!',
            msg: 'Số lần nhắc nhở phải lớn hơn hoặc bằng 0.',
          });
          return;
        }
        const currentCount = this.reminders.remind.length;

        if (newValue > currentCount) {
          for (let i = currentCount; i < newValue; i++) {
            this.reminders.remind.push({ date: '', time: '', content: '' });
          }
        } else if (newValue < currentCount) {
          this.reminders.remind.splice(newValue);
        }
      },
      immediate: true,
    },
  },
  methods: {
    selected(value, formProperty, optionsArr) {
      this.form[formProperty] =
        optionsArr.find((el) => el.value === value) || null;
      const selectedValue = this.form[formProperty];

      if (selectedValue || selectedValue?.value === 0) {
        this.$validator.reset({ name: formProperty });
        this.$validator.errors.remove(formProperty);
      }

      this.$nextTick(() => {
        this.$validator.validate(formProperty);
      });
    },
    resetData() {
      this.form.code = null;
      this.form.isActive = null;
      this.form.name = null;
      this.form.displayIndex = null;
      this.form.note = null;
      this.form.levelId = null;
      this.form.status = null;
      this.form.detailLink = null;
      this.form.redirectLink = null;
      this.reminders.RemindersCount = 0;
      this.$validator.reset();
    },
    async initDataInSelect() {
      try {
        this.loading = true;
      } catch (error) {
        console.error('Error fetching data:', error);
        // Handle error appropriately, e.g., show error message
      } finally {
        this.loading = false;
      }
    },
    mapDataSelect(response) {
      return response?.data.items.map((value) => {
        return {
          id: value?.id,
          text: value?.name ?? value?.description,
        };
      });
    },
    clear() {
      this.preview = null;
    },
    notBeforeToday(date) {
      return date > new Date();
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.errors.has(ref);
      }
      return null;
    },
    async returnPage() {
      (await this.handleConfirm())
        ? this.$router.push({
            name: 'activity_type_list',
          })
        : null;
    },
    async handleConfirm() {
      let confirm = await this.$swal({
        text: 'Các thay đổi sẽ không được lưu trữ, bạn có chắc muốn huỷ?',
        icon: 'warning',
        buttons: {
          cancel: {
            text: 'Quay lại',
            value: false,
            visible: true,
            className: '',
            closeModal: true,
          },
          confirm: {
            text: 'Huỷ',
            value: true,
            visible: true,
            className: 'btn-warning',
            closeModal: true,
          },
        },
      });
      return confirm;
    },
    async handleValidate() {
      let result = await this.$validator.validateAll();
      if (!result) {
        return;
      } else {
        this.submit();
      }
    },
    async submit() {
      if (isNaN(this.reminders.RemindersCount)) return;
      let payload = new FormData();
      const isCreateForm = this.isCreateForm;

      if (this.form.code) payload.append('code', this.form.code);
      if (this.form.name) payload.append('name', this.form.name);
      if (this.levelValue) payload.append('prelevel', this.levelValue);
      if (this.form.color) payload.append('color', this.form.color);
      if (this.form.status !== null && this.form.status !== undefined) {
        const statusValue =
          typeof this.form.status === 'object'
            ? this.form.status.value
            : this.form.status;
        payload.append('status', statusValue);
      }
      if (this.form.detailLink)
        payload.append('predetailLink', this.form.detailLink);
      if (this.form.redirectLink)
        payload.append('preredirectLink', this.form.redirectLink);
      if (
        this.form.displayIndex !== null &&
        this.form.displayIndex !== undefined
      )
        payload.append('displayIndex', this.form.displayIndex);
      if (this.form.note) payload.append('note', this.form.note);
      if (this.reminders.RemindersCount)
        payload.append('preReminderNumber', this.reminders.RemindersCount);
      if (this.reminders.remind && this.reminders.remind.length > 0) {
        payload.append(
          'preReminderContain',
          JSON.stringify(this.preReminderContain),
        );
      }
      let confirm = await this.$swal({
        text: `${
          isCreateForm
            ? 'Bạn có chắc muốn tạo loại hoạt động mới này không? '
            : 'Bạn có chắc muốn cập nhật thông tin loại hoạt động này hay không?'
        }`,
        icon: 'warning',
        buttons: {
          cancel: {
            text: 'Huỷ',
            value: false,
            visible: true,
            className: '',
            closeModal: true,
          },
          confirm: {
            text: 'Xác nhận',
            value: true,
            visible: true,
            className: 'btn-success',
            closeModal: true,
          },
        },
      });
      if (confirm) {
        if (isCreateForm) {
          this.handleCreate(payload);
        } else {
          this.handleUpdate(payload);
        }
      }
    },
    async handleCreate(payload) {
      try {
        this.loading = true;
        await this.$api.post(`ActivityType`, payload);
        this.$toastr.s({
          title: 'Thành công!',
          msg: 'Chúc mừng, Loại hoạt động mới đã được tạo!',
        });
        this.$router.push({ name: 'activity_type_list' });
      } catch (e) {
        this.$toastr.e({
          title: 'Lỗi!',
          msg: e.message,
        });
      } finally {
        this.loading = false;
      }
    },
    async handleUpdate(payload) {
      payload.append('id', this.form.id);
      try {
        this.loading = true;
        const id = this.form.id;
        await this.$api.put(`ActivityType/${id}`, payload);
        this.$toastr.s({
          title: 'Thành công!',
          msg: 'Chúc mừng, Loại hoạt động đã được cập nhật!',
        });
        this.$router.push({ name: 'activity_type_list' });
      } catch (e) {
        this.$toastr.e({
          title: 'Lỗi!',
          msg: e.message,
        });
      } finally {
        this.loading = false;
      }
    },
    async deleteRow(index) {
      let confirm = await this.$swal({
        text: 'Bạn có chắc muốn xóa nhắc nhở này không?',
        icon: 'warning',
        buttons: {
          cancel: {
            text: 'Huỷ',
            value: false,
            visible: true,
            className: '',
            closeModal: true,
          },
          confirm: {
            text: 'Xác nhận',
            value: true,
            visible: true,
            className: 'btn-success',
            closeModal: true,
          },
        },
      });
      if (confirm) {
        // if (this.reminders.RemindersCount <= 1) {
        //   this.$toastr.e({
        //     title: 'Lỗi !',
        //     msg: 'Tối thiểu là 1 nhắc nhở',
        //   });
        //   return;
        // } else {
        this.reminders.RemindersCount = this.reminders.RemindersCount - 1;
        this.reminders.remind.splice(index, 1);
        // }
      }
    },
    async loadActivityTypeData() {
      if (!this.$route.params.id) return;
      try {
        this.loading = true;
        const id = this.$route.params.id;
        let { data } = await this.$api.get(`ActivityType/${id}`);

        this.form = {
          id: data.id,
          code: data.code,
          name: data.name,
          levelId: data.preLevel,
          status: data.status,
          detailLink: data.preDetailLink,
          redirectLink: data.preRedirectLink,
          displayIndex: data.displayIndex,
          note: data.note,
          color: data.color,
        };

        const reminders = JSON.parse(data.preReminderContain) || [
          { date: '', time: '', content: '' },
        ];
        this.reminders = {
          RemindersCount: data.preReminderNumber ? data.preReminderNumber : 0,
          remind: reminders.map((reminder) => ({
            date: reminder.date ? reminder.date : '',
            time: reminder.time,
            content: reminder.content,
          })),
        };

        await this.getProgramActivityLevel();

        const level = this.setupList.levels.find(
          (l) => l.value === data.preLevel,
        );
        if (level) {
          this.form.levelId = level;
        }

        this.reminders.remind = this.reminders.remind.map((reminder) => {
          const activityReminder = this.setupList.activityReminders.find(
            (ar) => ar.value === reminder.date,
          );
          return {
            ...reminder,
            date: activityReminder || { name: '', value: '' },
          };
        });

        const statusOption = this.status.find((s) => s.value === data.status);
        if (statusOption) {
          this.form.status = statusOption;
        }
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi!',
          msg: error.message || 'Không thể tải dữ liệu Loại hoạt động',
        });
      } finally {
        this.loading = false;
      }
    },
    async getProgramActivityLevel() {
      try {
        const { data } = await this.$api.get('ProgramActivityLevel/setup-list');
        this.setupList = {
          levels: data.Levels.map((item) => ({
            name: item.Name,
            value: item.Id,
          })),
          activityReminders: data.ActivityReminders.map((item) => ({
            name: item.Name,
            value: item.Id,
          })),
        };
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi!',
          msg: error,
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.pictureInput {
  position: relative;
}
.icon-edit {
  z-index: 100;
  position: absolute;
  top: -15px;
  right: -6px;
  padding: 2px 6px;
  box-shadow: -1px 2px 10px rgba(0, 0, 0, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  width: fit-content;
  background-color: #fff;
}
.aterisk {
  color: #f64e60;
  font-size: 0.9rem;
}
</style>
